import { T } from '../../styles/theme'

const DEFAULT_SERIES = [
  { key: 'grasa', label: '% Grasa' },
  { key: 'magra', label: '% Masa magra' },
]

export default function CompositionChart({ data, series, theme = T, width = 320, height = 130 }) {
  const W = width, H = height, PL = 30, PB = 24, PT = 10, PR = 30
  const cW = W - PL - PR, cH = H - PB - PT
  const seriesConfig = series ?? [
    { ...DEFAULT_SERIES[0], color: theme.danger },
    { ...DEFAULT_SERIES[1], color: theme.accent },
  ]

  if (!data || data.length < 2) return (
    <div style={{ textAlign: 'center', color: theme.muted, padding: 20, fontSize: 13 }}>
      Necesitas al menos 2 mediciones para ver la gráfica
    </div>
  )

  const n = data.length
  const xScale = i => PL + (i / (n - 1)) * cW

  // Cada serie usa su propia escala vertical: grasa y masa magra suelen
  // moverse en rangos muy distintos, y compartir un único eje aplana una de las dos líneas.
  const scales = seriesConfig.map(({ key }) => {
    const vals = data.map(d => d[key]).filter(v => v != null)
    if (vals.length < 2) return null
    const minV = Math.min(...vals) - 1
    const maxV = Math.max(...vals) + 1
    return { minV, maxV, yScale: v => PT + (1 - (v - minV) / (maxV - minV)) * cH }
  })

  const ticksFor = scale => [scale.minV, (scale.minV + scale.maxV) / 2, scale.maxV].map(v => Math.round(v * 10) / 10)

  return (
    <svg width="100%" viewBox={`0 0 ${W} ${H}`}>
      {/* Líneas de referencia de puntos, una por cada valor del eje, igual que en la gráfica de peso */}
      {scales[0] && ticksFor(scales[0]).map(v => (
        <line key={'gl' + v} x1={PL} x2={W - PR} y1={scales[0].yScale(v)} y2={scales[0].yScale(v)} stroke={theme.cardB} strokeWidth="1" strokeDasharray="3,3" />
      ))}
      {seriesConfig.map((s, si) => {
        const scale = scales[si]
        if (!scale) return null
        const pts = data.map((d, i) => d[s.key] != null ? `${xScale(i)},${scale.yScale(d[s.key])}` : null).filter(Boolean).join(' ')
        return <polyline key={s.key} fill="none" stroke={s.color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" points={pts} />
      })}
      {/* Eje izquierdo: primera serie, con sus valores coloreados a juego con la línea */}
      {scales[0] && ticksFor(scales[0]).map(v => (
        <text key={'l' + v} x={PL - 4} y={scales[0].yScale(v) + 3} textAnchor="end" fontSize="8" fill={seriesConfig[0].color} fontFamily="DM Mono, monospace">{v}</text>
      ))}
      {/* Eje derecho: segunda serie */}
      {scales[1] && ticksFor(scales[1]).map(v => (
        <text key={'r' + v} x={W - PR + 4} y={scales[1].yScale(v) + 3} textAnchor="start" fontSize="8" fill={seriesConfig[1].color} fontFamily="DM Mono, monospace">{v}</text>
      ))}
      {data.filter((_, i) => i === 0 || i === Math.floor(n / 2) || i === n - 1).map((d) => {
        const i = data.indexOf(d)
        return <text key={i} x={xScale(i)} y={H - 4} textAnchor="middle" fill={theme.muted} fontSize="9" fontFamily="DM Sans, sans-serif">{d.label}</text>
      })}
      <line x1={PL} x2={PL} y1={PT} y2={H - PB} stroke={theme.cardB} strokeWidth="1" />
      <line x1={PL} x2={W - PR} y1={H - PB} y2={H - PB} stroke={theme.cardB} strokeWidth="1" />
    </svg>
  )
}

export { DEFAULT_SERIES }
